export const disableNDSforDcrUnlock = (appSettingsDataObj: any) => {
  let returnObj: any = {};
  appSettingsDataObj.map(
    (setting: any) => (returnObj[setting.code] = {...setting}),
  );
  return returnObj;
};
